import script from "./PostTo.vue?vue&type=script&setup=true&lang=js"
export * from "./PostTo.vue?vue&type=script&setup=true&lang=js"

import "./PostTo.vue?vue&type=style&index=0&id=3ad486d8&lang=scss"

const __exports__ = script;

export default __exports__